// Opens the one Give Feedback dialog (mounted in AppLayout) from anywhere:
// the profile menu, Preferences, the help links, the Overview.
import { ref } from 'vue'

const open = ref(false)
const kind = ref<'general' | 'cancellation'>('general')

export function useFeedbackDialog() {
  return {
    open,
    kind,
    show(k: 'general' | 'cancellation' = 'general') {
      kind.value = k
      open.value = true
    },
  }
}
